export enum CategorySortOrder {
    RECENT = "recent",
    NAME_ASC = "name",
    NAME_DESC = "-name",
    MEMBERS = "members",
    MEDIA_COUNT = "mediacount",
    UPDATE_DATE = "updatedate",
    MANUAL = "manual",
}
